// extracted by mini-css-extract-plugin
export default {"iconWrapper":"_445d2c8a _ba6c7799","active":"_b2929b3e"};